import ROUTING_STATE_SHAPE from 'rlink-router/ROUTING_STATE_SHAPE';

export default function getNextTransition (routing) {
  return ROUTING_STATE_SHAPE.getAt(routing, ['nextTransition']);
}



// WEBPACK FOOTER //
// ./lib/rlink-router/getNextTransition.js